import { render, staticRenderFns } from "./EducationalCalculator.vue?vue&type=template&id=fcdf32e2&scoped=true"
import script from "./EducationalCalculator.vue?vue&type=script&lang=js"
export * from "./EducationalCalculator.vue?vue&type=script&lang=js"
import style0 from "./EducationalCalculator.vue?vue&type=style&index=0&id=fcdf32e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdf32e2",
  null
  
)

export default component.exports